"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityContextProvider = exports.useIdentityContextProviderProps = exports.SignOut = exports.SignUp = exports.ForgotPassword = exports.VerifyContact = exports.ConfirmSignIn = exports.SignIn = void 0;
var tslib_1 = require("tslib");
var auth_1 = require("@aws-amplify/auth");
var core_1 = require("@reactionable/core");
var aws_amplify_react_1 = require("aws-amplify-react");
var types_1 = require("aws-amplify-react/lib-esm/Auth/common/types");
var react_1 = tslib_1.__importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var aws_amplify_react_2 = require("aws-amplify-react");
Object.defineProperty(exports, "SignIn", { enumerable: true, get: function () { return aws_amplify_react_2.SignIn; } });
Object.defineProperty(exports, "ConfirmSignIn", { enumerable: true, get: function () { return aws_amplify_react_2.ConfirmSignIn; } });
Object.defineProperty(exports, "VerifyContact", { enumerable: true, get: function () { return aws_amplify_react_2.VerifyContact; } });
Object.defineProperty(exports, "ForgotPassword", { enumerable: true, get: function () { return aws_amplify_react_2.ForgotPassword; } });
Object.defineProperty(exports, "SignUp", { enumerable: true, get: function () { return aws_amplify_react_2.SignUp; } });
Object.defineProperty(exports, "SignOut", { enumerable: true, get: function () { return aws_amplify_react_2.SignOut; } });
var dataToUser = function (data) {
    if (!data) {
        return null;
    }
    return {
        displayName: function () { var _a; return ((_a = data === null || data === void 0 ? void 0 : data.attributes) === null || _a === void 0 ? void 0 : _a.email) || ''; },
    };
};
function IdentityComponent(_a) {
    var setUser = _a.setUser, props = tslib_1.__rest(_a, ["setUser"]);
    var t = react_i18next_1.useTranslation().t;
    var authenticatorProps = Object.assign({
        errorMessage: function (message) { return t(message); },
        usernameAttributes: types_1.UsernameAttributes.EMAIL,
        signUpConfig: {
            hideAllDefaults: true,
            signUpFields: [
                {
                    label: 'Email',
                    key: 'email',
                    required: true,
                    displayOrder: 1,
                    type: 'string',
                },
                {
                    label: 'Password',
                    key: 'password',
                    required: true,
                    displayOrder: 2,
                    type: 'password',
                },
            ],
        },
    }, props);
    return (react_1.default.createElement(aws_amplify_react_1.Authenticator, tslib_1.__assign({}, authenticatorProps, { onStateChange: function (authState, data) {
            setUser(authState !== 'signedIn' ? null : dataToUser(data));
        }, children: [aws_amplify_react_1.SignIn, aws_amplify_react_1.ConfirmSignIn, aws_amplify_react_1.VerifyContact, aws_amplify_react_1.ForgotPassword] })));
}
exports.useIdentityContextProviderProps = function (props) {
    if (props === void 0) { props = {}; }
    return tslib_1.__assign({ identityProvider: 'Amplify', logout: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, auth_1.Auth.signOut()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }, getUser: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, auth_1.Auth.currentUserInfo()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, dataToUser(data)];
                }
            });
        }); }, Component: IdentityComponent }, props);
};
exports.IdentityContextProvider = function (props) {
    return react_1.default.createElement(core_1.IdentityContextProvider, tslib_1.__assign({}, exports.useIdentityContextProviderProps(), props));
};
//# sourceMappingURL=Identity.js.map